import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion"
import { useNavigate } from 'react-router-dom'
import { ReactSVG } from 'react-svg'

import './refractsalepage.css'

import refractPlaceholder from '../assets/RefractPromoImg3.jpg'
import AddToCartButton from '../assets/AddToCartButton.svg'
import AddToCartButtonPhone from '../assets/AddToCartButtonPhone.svg'
import TsSliders from '../assets/TSSliders2.svg'

import vstimg from '../assets/VSTLogoTs.png'
import auimg from '../assets/AULogoTS.png'
import aaximg from '../assets/AAXLogoTS.png'

import { UserAuth } from '../context/AuthContext'
import { analytics } from '../firebase'
import { logEvent } from 'firebase/analytics'

const RefractSalepage = () => {
    const [alreadyOwnesProduct, setAlreadyOwnesProduct] = useState(false);
    const [allOwnedProducts, setAllOwnedProducts] = useState([]);

    const { user } = UserAuth();
    const navigate = useNavigate();

    // Price for Refract Sale
    const price = 29.99;
    const originalPrice = 49.99;

    useEffect(() => {
        // Check if user owns Refract
        const hasRefract = allOwnedProducts.some((product) => product.name === "refract");
        if (hasRefract) {
            setAlreadyOwnesProduct(true);
        }
    }, [allOwnedProducts])


    const buyProduct = () => {
        logEvent(analytics, "SalePage_Refract_BuyNow");
        navigate('/checkout', { state: { product: { id: 2, name: "Refract", price: price } } });
    };

    return (
        <div className='refractsalepage__container'>
            <div className="refractsalepage__ontop">

                <motion.div className="refractsalepage__prodimg"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <img src={refractPlaceholder} alt="Refract Placeholder" className='refractsalepage__pluginimgsize' />
                </motion.div>

                <div className="refractsalepage__prodinfo">
                    <div className="refractsalepage__leftside">
                        <motion.div className="refractsalepage__title"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                        >
                            Refract
                        </motion.div>

                        <motion.div className="refractsalepage__description"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.4, duration: 0.5 }}
                        >
                            A revolutionary multiband processor. Add any VST3 or AU plugin to a specific frequency band, effectively turning every plugin in your arsenal into a multi-band powerhouse.
                        </motion.div>
                    </div>

                    <motion.div className="refractsalepage__sliders"
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.6, duration: 0.5 }}
                    >
                        <ReactSVG src={TsSliders} className="refractsalepage__sliderssize" />
                    </motion.div>

                    <div className="refractsalepage__rightside">
                        <motion.div className="refractsalepage__titleright"
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                        >
                            Multiband FX
                        </motion.div>

                        <motion.div className="refractsalepage__price"
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.4, duration: 0.5 }}
                        >
                            <span>${originalPrice}</span> ${price}
                        </motion.div>

                        <motion.div className="refractsalepage__addtocartbutton"
                            onClick={buyProduct}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.6 }}
                        >
                            <div className="refractsalepage__buttontext">
                                {alreadyOwnesProduct ? "Owned" : "Buy Now"}
                            </div>

                        </motion.div>

                        <motion.div className="refractsalepage__addtocartbuttonphone"
                            onClick={buyProduct}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.6 }}
                        >
                            <div className="refractsalepage__buttontext">
                                {alreadyOwnesProduct ? "Owned" : "Buy Now"}
                            </div>

                        </motion.div>

                    </div>
                </div>

                {/* Placeholder Video Section */}
                <motion.div className="refractsalepage__videoplaceholder"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                </motion.div>

                {/* Powerful Features Section */}
                <motion.div className="refractsalepage__featurebox"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                >
                    <div className="refractsalepage__featuretitle">Transform Your Plugins</div>
                    <div className="refractsalepage__featuregrid">
                        <div className="refractsalepage__featureitem">
                            <h3>Multiband Anything</h3>
                            <p>Load your favorite compressor, distortion, or modulation plugin and apply it solely to the lows, mids, or highs with precision crossovers.</p>
                        </div>
                        <div className="refractsalepage__featureitem">
                            <h3>Surgical Control</h3>
                            <p>Isolate problematic frequencies, expand your sound design capabilities, and bring focus to your mix without affecting the entire frequency spectrum.</p>
                        </div>
                        <div className="refractsalepage__featureitem">
                            <h3>Seamless Workflow</h3>
                            <p>Host VST3 and AU plugins directly inside Refract with zero latency overhead. Drag, drop, and dial in the perfect sound faster than ever.</p>
                        </div>
                        <div className="refractsalepage__featureitem">
                            <h3>Dynamic Phase Alignment</h3>
                            <p>Advanced crossover filters ensure minimal phase smearing, keeping your audio punchy, transparent, and absolutely pristine.</p>
                        </div>
                    </div>
                </motion.div>

                <div className="refractsalepage__moreinfo">
                    <motion.div className="refractsalepage__infobox"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                    >
                        <div className="refractsalepage__infoboxtitle">
                            Requirements
                        </div>
                        <div className="refractsalepage__infoboxtext">
                            macOS
                            macOS 10.13 or higher (64-bit only)
                            AU or VST3 host or Pro Tools
                            Apple Silicon or Intel processor
                            <br /><br />
                            The computer must be connected to the internet at the time of product registration. After the completion of registration, the software is designed to function offline.
                            <br /><br />
                            Windows support coming soon...
                        </div>
                    </motion.div>

                    <motion.div className="refractsalepage__infobox"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.4 }}
                    >
                        <div className="refractsalepage__infoboxtitle">
                            Plug-in formats
                        </div>
                        <div className="refractsalepage__infoboxtext">
                            Tape Signal plug-ins are available
                            in VST, VST3, Audio Units, AAX Native
                            and AudioSuite formats.
                        </div>
                        <div className="refractsalepage__formatimgs">
                            <img src={vstimg} alt="VST" />
                            <img src={auimg} alt="AU" />
                            <img src={aaximg} alt="AAX" />
                        </div>
                    </motion.div>
                </div>

            </div>
        </div>
    )
}

export default RefractSalepage
